import React from 'react';
import Keycloak from 'keycloak-js';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import AppRoutes from './AppRoutes';

const keycloak = new Keycloak({
  url: 'https://weavevo.com/auth',
  realm: 'master',
  clientId: 'account'
});

const KeycloakWrapper = () => {
  const onKeycloakLogout = () => {
    keycloak.logout({ redirectUri: window.location.origin });
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'check-sso',
        redirectUri: window.location.origin + '/dashboard',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256'
      }}
    >
      <AppRoutes keycloak={keycloak} onLogout={onKeycloakLogout} />
    </ReactKeycloakProvider>
  );
};

export default KeycloakWrapper;
